'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../utils/cn';

const badgeVariants = cva(
  'inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap transition-[color,box-shadow] focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-[color:var(--primary-solid-border)] bg-primary-solid text-primary-solid-foreground [a&]:hover:bg-primary-solid-hover',
        secondary:
          'border-[color:var(--chip-border)] bg-[color:var(--chip-bg)] font-normal text-[color:var(--chip-fg)] [a&]:hover:opacity-90',
        success:
          'border-[color:var(--ok-border)] bg-[color:var(--ok-bg)] font-normal text-[color:var(--ok-fg)] [a&]:hover:opacity-90',
        warning:
          'border-[color:var(--warn-border)] bg-[color:var(--warn-bg)] font-normal text-[color:var(--warn-fg)] [a&]:hover:opacity-90',
        info: 'border-[color:var(--info-border)] bg-[color:var(--info-bg)] font-normal text-[color:var(--info-fg)] [a&]:hover:opacity-90',
        destructive:
          'border-[color:var(--destructive-border)] bg-destructive text-destructive-foreground [a&]:hover:bg-destructive/90',
        outline:
          'border-[color:var(--chip-border)] bg-transparent font-normal text-[color:var(--chip-fg)] [a&]:hover:bg-[color:var(--chip-bg)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
